var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 16 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M3.33 24L.5 21.171l9.339-9.175L.5 2.829 3.33 0 15.5 11.996 3.33 24z","fill":"#4C4541"}})])}
var staticRenderFns = []

export { render, staticRenderFns }